// 阿拉伯语
export default {
  locale: "zh-CN",
  language: "بالعربية",
  menu: {
    i18n: "متعدد اللغات"
  },
  page: {
    content: {
      MoreAndMore: "更多(阿拉伯语)",
      loginTip: "您尚未登录 请先登录(阿拉伯语)",
      blockNoData: "暂无更多公告(阿拉伯语)",
      supplierPortal: "首页(阿拉伯语)",
      projectCode: "项目编号(阿拉伯语)",
      publishTime: "发布时间(阿拉伯语)",
      labelMenu1: "评标结果(阿拉伯语)",
      labelMenu2: "流标公告(阿拉伯语)",
      labelMenu3: "补遗公告(阿拉伯语)",
      labelMenu4: "邀请公告(阿拉伯语)",
      labelMenu5: "中标通知(阿拉伯语)",
      labelMenu6: "招标采购(阿拉伯语)",
      labelMenu7: "询价采购(阿拉伯语)",
      labelMenu8: "竞争谈判(阿拉伯语)",
      projectNamePlaceholder: "请输入项目名称(阿拉伯语)",
      search: "搜索(阿拉伯语)",
      allClassify: "全部分类(阿拉伯语)",
      menu1: "首页(阿拉伯语)",
      menu2: "集中采购(阿拉伯语)",
      menu3: "区域联采(阿拉伯语)",
      menu4: "分包商注册(阿拉伯语)",
      menu5: "供应链金融(阿拉伯语)",
      Hello: "您好(阿拉伯语)",
      Exit: "退出(阿拉伯语)",
      supplierLogin: "Hi,欢迎回来(阿拉伯语)",
      pleaseLogin: "登录交建云商(阿拉伯语)",
      Announcements: "通知公告(阿拉伯语)",
      subpackage: "分包(阿拉伯语)",
      purchase: "采购(阿拉伯语)",
      projectName: "项目名称(阿拉伯语)",
      searchPlaceholder: "搜索 项目公告(阿拉伯语)",
      packageNum: "包件数量(阿拉伯语)",
      fromEndTime: "距离结束(阿拉伯语)",
      viewDetail: "查看详情(阿拉伯语)",
      downLoad: "下载(阿拉伯语)",
      to: "至(阿拉伯语)",
      startTime: "开始时间(阿拉伯语)",
      endTime: "结束时间(阿拉伯语)",
      joinStatus: "参与状态(阿拉伯语)",
      title: "标题(阿拉伯语)",
      titlePlaceholder: "请输入标题模糊查询(阿拉伯语)",
      serialNo: "序号(阿拉伯语)",
      publishUnit: "发布单位(阿拉伯语)",
      signUpEndTime: "报名结束剩余时间(阿拉伯语)",
      day: "天(阿拉伯语)",
      hour: "时(阿拉伯语)",
      minute: "分(阿拉伯语)",
      second: "秒(阿拉伯语)",
      immediatelySignUp: "立即报名（仅分包商可报名）(阿拉伯语)",
      notice: "公告(阿拉伯语)",
      noticeTitle: "公告标题(阿拉伯语)",
      noticeContent: "公告内容(阿拉伯语)",
      contractInfo: "联系信息(阿拉伯语)",
      fileList: "附件列表(阿拉伯语)",
      supplierBiddingProcess: "分包商投标操作流程(阿拉伯语)",
      pleaseClickView: "请点击查看(阿拉伯语)",
      packageDesc: "包件说明(阿拉伯语)",
      materialInfo: "物资信息(阿拉伯语)",
      relatedNoticeList: "相关公告列表(阿拉伯语)",
      purchaseMoney: "采购金额(阿拉伯语)",
      thousandYuan: "万元(阿拉伯语)",
      camulativePurchaseItems: "累计招标项目(阿拉伯语)",
      inquiryProjectNum: "询价项目数量(阿拉伯语)",
      biddingProjectNum: "竞谈项目数量(阿拉伯语)",
      unitStillPurchase: "该单位还在采购(阿拉伯语)",
      fileName: "附件名称(阿拉伯语)",
      fileSize: "附件大小(阿拉伯语)",
      fileDesc: "附件说明(阿拉伯语)",
      operation: "操作(阿拉伯语)",
      code: "编码(阿拉伯语)",
      name: "名称(阿拉伯语)",
      num: "采购数量(阿拉伯语)",
      unit: "项目特征描述(阿拉伯语)",
      remark: "备注(阿拉伯语)",
      type: "类型(阿拉伯语)",
      link: "环节(阿拉伯语)",
      other: "其他(阿拉伯语)",
      aboutUs: "关于我们(阿拉伯语)",
      introPlatform: "平台简介(阿拉伯语)",
      contactUs: "联系我们(阿拉伯语)",
      relevantPoliciesAndRegulations: "相关政策与规范(阿拉伯语)",
      purchaser: "采购方(阿拉伯语)",
      operationGuide: "操作指引(阿拉伯语)",
      videoTutorial: "视频教程(阿拉伯语)",
      supplier: "分包商(阿拉伯语)",
      supplierName: "分包商名称(阿拉伯语)",
      netInformation: "入网须知(阿拉伯语)",
      commonProblem: "常见问题(阿拉伯语)",
      purchaseCommonProblem: "采购方常见问题(阿拉伯语)",
      supplierCommonProblem: "分包商常见问题(阿拉伯语)",
      serviceCenter: "服务中心(阿拉伯语)",
      onlineCounsel: "在线咨询(阿拉伯语)",
      afterSalesService: "售后服务(阿拉伯语)",
      feedback: "意见反馈(阿拉伯语)",
      fileTemplateDownload: "文件模板下载(阿拉伯语)",
      supplyChainFinanceCenter: "供应链金融中心(阿拉伯语)",
      officialWeChat: "官方微信(阿拉伯语)",
      navigation: "栏目导航(阿拉伯语)",
      source: "来源(阿拉伯语)",
      add: "新增(阿拉伯语)",
      author: "作者(阿拉伯语)",
      publishDate: "发布日期(阿拉伯语)",
      all: "全部(阿拉伯语)",
      prev: "< 上一页(阿拉伯语)",
      next: "下一页 >(阿拉伯语)",
      sure: "确定(阿拉伯语)",
      noRelatedData: "暂无相关数据(阿拉伯语)",
      supplierOperationManual: "分包商操作手册(阿拉伯语)",
      operationManual: "操作手册(阿拉伯语)",
      supplierOperationGuide: "分包商操作指南(阿拉伯语)",
      noData: "暂无数据(阿拉伯语)",
      question: "业务流程及常见问题(阿拉伯语)",
      purchaseType: "采购方式(阿拉伯语)",
      materialClassify: "物资分类(阿拉伯语)",
      projectCategory: "工程类别(阿拉伯语)",
      multiSelect: "多选(阿拉伯语)",
      cancel: "取消(阿拉伯语)",
      onlySupplierLogin: "仅分包商登录可选(阿拉伯语)",
      publicBidding: "公开招标(阿拉伯语)",
      inquiry: "询价采购(阿拉伯语)",
      competitiveNegotiation: "竞争性谈判(阿拉伯语)",
      invitationTender: "邀请招标(阿拉伯语)",
      nearly3Days: "近3天(阿拉伯语)",
      nearly7Days: "近一周(阿拉伯语)",
      nearly30Days: "近一个月(阿拉伯语)",
      toMyProject: "进入项目(阿拉伯语)"
    },
    sup: {
      title: "إدارة معلومات التسجيل",
      content1: "中国交建电子采购平台 —— 分包商门户（(阿拉伯)",
      content2:
        "）是分包商加入中国交通建设股份有限公司（以下简称“中国交建”）分包商网络的唯一合法的电子商务网站。中国交建按照“互利共赢、诚信合作”的原则，与分包商建立积极的合作关系。(阿拉伯)",
      content3:
        "中国交建对分包商实行准入管理，经准入的分包商具备参与中国交建及所属企业的线上投标和报价资格。凡有意参与中国交建采购业务的分包商均须认真阅读入网须知及注册指南，选择(阿拉伯)",
      content4:
        "注册（推荐单位为分包商信息的初审单位），经审核通过后入网。(阿拉伯)",
      content5: "请为保证系统的稳定兼容性，请使用(阿拉伯)",
      content6:
        "或以上版本的IE浏览器（同时选择兼容模式），以获得最佳效果。设置方法参见：(阿拉伯)",
      contentStrong: " التصريح شركة ",
      questions: "مشكلة شائعة",
      explain: "其他说明如下：(阿拉伯)",
      explain1: "1. إشعار التسجيل",
      explain2: "2. 注册流程(阿拉伯)",
      explain3: "3. مشكلة شائعة",
      explain4: "4. دليل التشغيل",
      explain5: "5. 如何找回密码(阿拉伯)",
      explain6: "6. 分包商在线投标重要提示及操作流程(阿拉伯)",
      supNetInformation: "إشعار التسجيل",
      netInformation1:
        "1.中国交通建设股份有限公司设备物资采购管理信息平台是分包商加入中国交通建设股份有限公司（以下简称“中国交建”）分包商网络的唯一合法网站。中国交建按照“互利共赢、诚信合作”的原则，与分包商建立积极的合作关系。(阿拉伯)",
      netInformation2:
        "2.中国交通建设股份有限公司对申请入网的分包商不收取任何费用，不颁发相关证书，也不以年审、会员制、业绩考核等名义向分包商收取费用。分包商填写入网信息必须真实、准确并及时更新。(阿拉伯)",
      netInformation3:
        "3. 如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。(阿拉伯)",
      faqName: "分包商在线投标重要提示及操作流程(阿拉伯)",
      createUserName: "中国交通建设股份有限公司(阿拉伯)",
      releaseMechanism: "发布机构：(阿拉伯)",
      releaseTime: "发布时间：(阿拉伯)",
      titleContent:
        "为保障招标活动的顺利进行，请投标分包商认真阅读以下内容：(阿拉伯)",
      titleContent1:
        "一、避开投标高峰时间：高峰时间（8:00—18:00），特别是投标截止日前一天。(阿拉伯)",
      titleContent2:
        "二、控制投标文件大小：投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件和图片尺寸。(阿拉伯)",
      titleContent3:
        "三、投标操作：建议分包商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。(阿拉伯)",
      titleContent4: "四、具体演示：(阿拉伯)",
      operationProcess: "分包商投标操作流程(阿拉伯)",
      clickOnTitleToView: "点击标题查看(阿拉伯)",
      table: {
        title: "附件列表(阿拉伯)",
        serialNumber: "رقم", //序号
        fileName: "الاسم ", //附件名称
        fileSize: "الحجم", //附件大小
        fileDesc: "الوصف", //附件说明
        operation: "التشغيل", //操作
        upload: "下载(阿拉伯)"
      },
      dialog: {
        title: "关于分包商在线投标的重要提示(阿拉伯)",
        dialogTitle:
          "为保障招标活动的顺利进行，请投标分包商认真阅读以下内容：(阿拉伯)",
        content1: "一、避开投标高峰时间(阿拉伯)",
        contentP1:
          "高峰时间（每日6:00—18:00），特别是投标截止日前一天。(阿拉伯)",
        content2: "二、控制投标文件大小(阿拉伯)",
        contentP2:
          "投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件。(阿拉伯)",
        content3: "三、投标操作(阿拉伯)",
        contentP3:
          "建议分包商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。投标操作具体演示如下：(阿拉伯)",
        participateInBidd: "1.参与招标(阿拉伯)",
        participateInBiddCont1:
          "1)使用IE浏览器登陆分包商门户网站（http://uat01-sp.iccec.cn）(阿拉伯)",
        participateInBiddCont2:
          "2)登陆后点击邀请公告。点击一条公告进入后，网页下方有一个参与按钮，点击进入填写联系信息并提交。此时系统会提示您已“报名成功”。(阿拉伯)",
        biddingDocuments: "2.下载招标文件(阿拉伯)",
        biddingDocumentsCont1:
          "1)招标人收到标书费用，会通过系统给分包商发送招标文件，您在待办提醒里可以看到采购文件下载(阿拉伯)",
        biddingDocumentsCont2:
          "2)待办提醒还可以提供答疑、投标、补遗、澄清等信息。(阿拉伯)",
        tender: "3.投标",
        tenderCont1: "1)投标阶段开始后请查看待办提醒，点击。(阿拉伯)",
        tenderCont2:
          "2)分包商也可以点击分包商门户地址栏下方的业务协同，进入您的工作界面。(阿拉伯)",
        tenderCont3:
          "3)进入工作界面后，页面左侧有您参与的方案，点击方案后进入投标菜单进行投标。(阿拉伯)",
        tenderCont4:
          "4）为避免附件大造成投标失败，建议在投标结束前一天完成网上投标。(阿拉伯)",
        tenderCont5:
          "您也可以分步上传标书文件，首先填写报价表，并上传技术投标文件，点击提交按钮；此时系统提示(阿拉伯)",
        aTender: "投标成功(阿拉伯)",
        tenderCont6: "在商务报价表做好后，在投标菜单点击(阿拉伯)",
        tenderCont7:
          "按钮，修改报价，通过“上传”按钮把商务报价文件上传至系统后，点击提交完成最终报价。(阿拉伯)",
        tenderCont8:
          "备注：请不要点击撤销投标，点击后系统会删除所有投标文件。(阿拉伯)",
        reportAgain: "再次上报(阿拉伯)",
        toClarify: "4.澄清(阿拉伯)",
        toClarifyCont:
          "在评标阶段，招标方会通过系统发布澄清文件，请在待办提醒中查看并回复。(阿拉伯)",
        question: " 5.质疑(阿拉伯)",
        questionCont:
          "分包商如对招标文件有疑问，可通过点击首页的业务协同，在业务协同页面左侧找到参与的项目，点击参与的项目找到质疑答疑菜单，上传您的质疑文件，也可查看招标方答疑文件。(阿拉伯)",
        addendumFile: "6.查看补遗文件(阿拉伯)",
        addendumFileCont:
          "如果招标方发布补遗文件，您可以在首页的待办提醒里查看。(阿拉伯)",
        notes: "四、电子标书大小注意事项(阿拉伯)",
        notesCont1:
          "在制作投标文件的过程中，因投标书含有许多图片导致文件很大而影响上传。为避免提交标书时上传速度慢，请尽量压缩投标文件和图片尺寸，文件大小应控制在30M以内。也可以将Word文件转换为PDF格式并使用压缩包软件，压缩文件大小。(阿拉伯)",
        notesCont2: "1.转换为PDF格式有2种方法：(阿拉伯)",
        notesCont3:
          "1) 一种是在Word中直接另存为PDF格式，并压缩尺寸（含Office2007, 2010和2013版本）。(阿拉伯)",
        notesCont4:
          "2) 一种是安装PDF虚拟打印机，自动生成PDF文档。（Office2003不带PDF转换，就需要安装此软件，PDFCreator软件为开源软件，任何人都可以免费安装使用）。下载地址",
        click: "点击(阿拉伯)",
        notesCont5:
          "2.以下为Office 2007及以上版本直接另存为PDF格式的方法：(阿拉伯)",
        notesCont6:
          "1) 以Office2010为例，在Word文档中选择文件另存为，保存类型选择(阿拉伯)",
        notesCont7: "2) 在优化项选择“针对以下格式优化(阿拉伯)",
        notesCont8: "可将文件压缩至20M以内。(阿拉伯)",
        smallestFileSize: "最小文件大小(阿拉伯)",
        sure: "تأكيد", //确定
        cancel: "إلغاء", //取消
        spread: "展开(阿拉伯)",
        shrinkage: "收缩(阿拉伯)"
      }
    },
    login: {
      title: "分包商登录(阿拉伯语)",
      pwLogin: "密码登录(阿拉伯语)",
      smsLogin: "短信登录(阿拉伯语)",
      pleaseUn: "用户名/手机号(阿拉伯语)",
      pleasePw: "请输入密码(阿拉伯语)",
      loginName: "登录(阿拉伯语)",
      smsSendSuccessTip1: "短信验证码已发送至(阿拉伯语)",
      smsSendSuccessTip2: "请注意查收(阿拉伯语)",
      telNo: "手机号(阿拉伯语)",
      smsVerCode: "短信验证码(阿拉伯语)",
      sendVerCode: "发送验证码(阿拉伯语)",
      sended: "已发送(阿拉伯语)",
      jjt: "交建通(阿拉伯语)",
      wx: "微信(阿拉伯语)",
      Copyright: "Copyright © 2018 中国交建 All rights reserved.",
      statement: "最终解释权：闽ICP备2022005227号-2 中国交建(阿拉伯语)",
      acApiErrorObj: {
        error1: "该登录账号因无效登录超过6次已被锁定30分钟(阿拉伯语)",
        error2: "未实名(阿拉伯语)",
        error3: "登录账号已被冻结(阿拉伯语)",
        error4: "系统服务暂不可用，请稍后重试(阿拉伯语)"
      },
      pwApiErrorObj: {
        error1: "登录账号与登录密码不匹配，请重新输入(阿拉伯语)",
        error2: "请滑动完成验证(阿拉伯语)"
      },
      telErrorObj: {
        error1: "请输入正确的手机号(阿拉伯语)",
        error2: "手机号与短信密码不匹配，请重新输入。(阿拉伯语)",
        error3: "手机号短信验证码无效登录6次，将锁定手机号30分钟(阿拉伯语)",
        error4: "系统服务暂不可用,请稍后重试(阿拉伯语)"
      },
      smsSliderErrorObj: {
        error1: "请滑动完成验证(阿拉伯语)"
      },
      smsErrorObj: {
        error1: "请勿重复发送，倒计时完成后可再次获取验证码(阿拉伯语)",
        error2: "发送验证码失败,请稍后再试(阿拉伯语)"
      },
      upLang: {
        _startTEXT: "请按住滑块，拖动到最右侧(阿拉伯语)",
        _yesTEXT: "验证通过(阿拉伯语)",
        _noTEXT: "验证不通过(阿拉伯语)",
        _error300:
          '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次(阿拉伯语)',
        _errorNetwork:
          '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>(阿拉伯语)'
      }
    }
  }
};
